
export default class accountController {
    constructor($location, authenticationService) {
        this.authenticationService = authenticationService;
        this.$location = $location;
        this.username = "";
        this.password = "";
        const Http = new XMLHttpRequest();
        const url='https://splutter-hub-live.azurewebsites.net';
        Http.open("GET", url);
        Http.send();
    }

    onLogin() {
        this.authenticationService.requestToken({
            username: this.username,
            password: this.password
        }).then(resp => {
            this.authenticationService.setToken(resp.data.token);
            this.$location.path('/');
        }, resp => {
            this.resp = resp.data;
        });
    }
}


// WEBPACK FOOTER //
// ./src/js/components/auth/auth.controller.js